export default __webpack_public_path__ + "media/images/about_us/living-room-0dca5cb111fbebf75561dfd49fd441d9.png";